/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
type State = Object;
import {SET_CCPROJECTS_FINISHED, SET_CCPROJECTS_TIMEOUT_OR_ERROR} from '../types';

const initialState: {
	ccProjectsFetchFinished: boolean;
	ccProjectsTimeOutOrError: boolean;
} = {
	ccProjectsFetchFinished: false, // whether ccProjects has finished
	ccProjectsTimeOutOrError: false, // whether ccProjects errors or timeouts
};

export default (state: State = initialState, action) => {
	switch (action.type) {
		case SET_CCPROJECTS_FINISHED:
			return {
				...state,
				ccProjectsFetchFinished: true,
				ccProjectsTimeOutOrError: false,
			};
		case SET_CCPROJECTS_TIMEOUT_OR_ERROR:
			return {
				...state,
				ccProjectsFetchFinished: false,
				ccProjectsTimeOutOrError: true,
			};
		default:
			return state;
	}
};
